export default __webpack_public_path__ + "static/media/black-identify-multiple-features-icon.c0a53af8.svg";